import emoji from "emoji-dictionary"
import CodeFormatter from "../components/CodeFormatter"
import { fs } from "../controls/Constants"

const KariSequential = () => {
    const codeSnippet2 = `
#include <kari.h>
using namespace kari;

void setup(){
    Serial.begin(9600);
    kariBegin({8, 7, 6, 5});
}

void loop(){
    kariAsync::execute(
        [](){
            kariSequential({ {8, 7, 6, 5}, "sequential1"});
        },
        1500
    );
   
}
    `

    const introduction = 
    `The kariSequential class is a core component of the Kari IoT Library, designed to manage sequential pin states efficiently in Arduino-based projects.
    It provides a structured approach to handling and tracking sequential pin changes across multiple pins.
    This is useful in scenarios where ordered pin transitions are required, such as LED animations.\n
    This class ensures efficient state tracking, making it ideal for applications that require ordered transitions between pin states.
    `
    return (
        <>
        <section>
            <h1>{emoji.getUnicode("repeat")} kariSequential</h1>
            <h2>Introduction</h2>
            <p className={`text-formatter ${fs}`}>{introduction}</p>
        </section>
        <section>
                <h2>{emoji.getUnicode("wrench")} Key Features</h2>
                <ul className={`${fs}`}>
                    <li><strong>Automated Sequential Control</strong> - Easily manage pin sequences without manual tracking.</li>
                    <li><strong>Optimized for Performance</strong> - Ensures smooth transitions between states.</li>
                    <li><strong>Flexible Pin Assignments</strong> - Works with any digital pins on the Arduino.</li>
                    <li><strong>Ideal for LED Patterns</strong> - Great for animations and controlled motion.</li>

                
                </ul>
            </section>
            <h2>{emoji.getUnicode("hammer_and_wrench")} API Reference</h2>
            <CodeFormatter codeSnippet="void kariSequential(Pins array);" />
            <h3>Description:</h3>
            <ul className={`${fs}`}>
                <li> <b className="fs-20">array</b> - is a special struct of type Pins.It takes in two parameters.</li>
                <li>The first parameter is an array of integer pins and the second parameter is a unique string which works as an identifier.</li>
                <li>The string must be unique for kariSequential to work correctly.
                That means at no instance should more than one kariSequential use the same string as an identifier.
                </li>
                <li>{emoji.getUnicode("warning")}This should be taken with <strong>caution</strong> and 
                ensure each kariSequential uses a unique string identifier. </li>
            </ul>
            
        <h2>{emoji.getUnicode("hammer")} Basic Usage Example</h2>
        <CodeFormatter codeSnippet={codeSnippet2}/>
        </>
    )
}

export default KariSequential
